import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { BulkTransactionTitle } from '@/pages/HedgeAccountingAdminV2/store/types';

import {
  companyEntityList,
  companyEntityTransactions,
  fetchSearchTrades,
} from './companyEntityThunk';
import {
  CompanyEntityListResponse,
  CompanyEntityListSuccessPayload,
  CompanyEntityTransactions,
  CompanyEntityTransactionsResponse,
  SearchTradesResponse,
} from './types';

interface CompanyEntityState {
  entityTradesData: CompanyEntityTransactions[] | null;
  entityList: CompanyEntityListSuccessPayload[];
  entityListLoading: boolean;
  entityListLoaded: boolean;
  searchTrades: BulkTransactionTitle[];
  searchTradesLoaded: boolean;
  searchTradesLoading: boolean;
}

const initialCompanyEntityState: CompanyEntityState = {
  entityTradesData: [],
  entityList: [],
  entityListLoading: false,
  entityListLoaded: false,
  searchTrades: [],
  searchTradesLoaded: false,
  searchTradesLoading: false,
};

const CompanyEntitySlice = createSlice({
  name: 'companyEntity',
  initialState: initialCompanyEntityState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(companyEntityTransactions.pending, (state) => {
        state.entityTradesData = [];
      })
      .addCase(
        companyEntityTransactions.fulfilled,
        (state, action: PayloadAction<CompanyEntityTransactionsResponse>) => {
          state.entityTradesData = action.payload.data;
        },
      )
      .addCase(companyEntityTransactions.rejected, (state) => {
        state.entityTradesData = null;
      })

      .addCase(companyEntityList.pending, (state) => {
        state.entityList = [];
        state.entityListLoading = true;
        state.entityListLoaded = false;
      })
      .addCase(
        companyEntityList.fulfilled,
        (state, action: PayloadAction<CompanyEntityListResponse>) => {
          state.entityList = action.payload.data;
          state.entityListLoading = false;
          state.entityListLoaded = true;
        },
      )
      .addCase(companyEntityList.rejected, (state) => {
        state.entityList = [];
        state.entityListLoading = false;
        state.entityListLoaded = true;
      })

      .addCase(fetchSearchTrades.pending, (state) => {
        state.searchTradesLoading = true;
      })
      .addCase(fetchSearchTrades.fulfilled, (state, action: PayloadAction<SearchTradesResponse>) => {
        state.searchTrades = action.payload?.data?.transaction_titles ?? [];
        state.searchTradesLoaded = true;
        state.searchTradesLoading = false;
      })
      .addCase(fetchSearchTrades.rejected, (state) => {
        state.searchTradesLoaded = false;
        state.searchTradesLoading = false;
      });
  },
});

export default CompanyEntitySlice.reducer;
